import UserStore from '../stores/UserStore';
import { message } from 'antd';
import axios from 'axios';
import { API_ROOT, getAuthScopeHeaders } from '@partsbadger/utils';

const handleErrors = (error: any) => {
    //need good error handling
    // Need throw the error to handle error events on the page were is called

    if (!error?.response) {
        message.error(error?.message ? error?.message : 'Error');
    } else if (error?.response?.status === 500) {
        message.error(error?.message ? error?.message : 'Error');
    }

    throw error;
};

const responseBody = (resp: any) => {
    // right now both successful/unsuccessful calls go to the caller
    // routing them to a single component would be ideal to show errors
    // to the user

    return resp.data;
};

function getHeader() {
    if (UserStore.token) {
        return {
            'Content-Type': 'application/json',
            ...getAuthScopeHeaders(),
            Authorization: `Token ${UserStore.token}`,
        };
    } else {
        return {
            'Content-Type': 'application/json',
            ...getAuthScopeHeaders(),
        };
    }
}

/***
 * @deprecated use @partsbadger/utils
 */
const requests = {
    get: (url: string, options?: any) =>
        axios
            .get(`${API_ROOT}${url}`, {
                headers: getHeader(),
                ...options,
            })
            .then(responseBody)
            .catch(handleErrors),
    getWithoutHeader: (url: string, options?: any) =>
        axios
            .get(`${API_ROOT}${url}`, {
                ...options,
            })
            .then(responseBody)
            .catch(handleErrors),
    post: (url: string, data: any, options?: any) =>
        axios
            .post(`${API_ROOT}${url}`, data, {
                headers: getHeader(),
                ...options,
            })
            .then(responseBody)
            .catch(handleErrors),

    patch: (url: string, data: any) =>
        axios
            .patch(`${API_ROOT}${url}`, data, {
                headers: getHeader(),
            })
            .then(responseBody)
            .catch(handleErrors),

    delete: (url: string) =>
        axios
            .delete(`${API_ROOT}${url}`, {
                headers: getHeader(),
            })
            .then(responseBody)
            .catch(handleErrors),
};

/***
 * @deprecated We should use stores
 */
const User = {
    get: () => requests.get(`/rest-auth/user/`),
    login: (data: any) => requests.post(`/rest-auth/login/`, data, { withCredentials: true }),
    logout: () => requests.post(`/rest-auth/logout/`, {}, { withCredentials: true }),
    resend: () => requests.post(`/auth/resend-activation-link`, {}),
    resetPassword: (data: any) => requests.post(`/rest-auth/password/reset/`, data),
    restPasswordConfirm: (data: any) => requests.post(`/rest-auth/password/reset/confirm/`, data),
    changePassword: (data: any) => requests.post(`/rest-auth/password/change/`, data),
    register: (data: any) => requests.post(`/rest-auth/registration/`, data, { withCredentials: true }),
    referAFriend: (data: any) => requests.post(`/customer/refer-friend/`, data),

    requirements: () =>
        requests.get(`/customer/contacts/${UserStore.user?.default_contact?.id}/additional-requirements/`),
    requirementTypes: () => requests.get(`/customer/additional-requirements/`),
    updateRequirements: (data: any) =>
        requests.post(`/customer/contacts/${UserStore.user?.default_contact?.id}/additional-requirements/`, data),

    defaultContact: (id: number | string) => requests.post(`/auth/default-contact/${id}`, {}),

    getEmails: () => requests.get(`/customer/emails/`),
    getContacts: (params: any) => requests.get(`/customer/contacts/`, { params: params }),
    getContactInvoice: (id: number) => requests.get(`/customer/contacts/${id}/`),
    editContactInvoice: (data: any, id: number) => requests.post(`/customer/contacts/${id}/modify-email/`, {}),

    getContact: (id: number) => requests.get(`/customer/contacts/${id}/`),
    removeMobile: (id: number) => requests.post(`/customer/contacts/${id}/delete-mobile/`, {}),

    addEmail: (data: any) => requests.post(`/customer/emails/`, data),
    removeEmail: (id: number) => requests.delete(`/customer/emails/${id}/`),

    verifyEmail: (id: number) => requests.post(`/customer/emails/${id}/resend-verification/`, {}),
    setPrimary: (id: number) => requests.post(`/customer/emails/${id}/set-primary/`, {}),

    getAddresses: () => requests.get(`/customer/contacts/${UserStore.user?.default_contact?.id}/addresses/`),
    addAddress: (id: number, data: any) => requests.post(`/customer/contacts/${id}/addresses/`, data),
    editAddress: (data: any, id: number) =>
        requests.patch(`/customer/contacts/${UserStore.user?.default_contact?.id}/addresses/${id}/`, data),
    removeAddress: (id: number) =>
        requests.delete(`/customer/contacts/${UserStore.user?.default_contact?.id}/addresses/${id}/`),

    getTaxExemptions: () => requests.get(`/customer/contacts/${UserStore.user?.default_contact?.id}/tax-forms/`),
    editTaxExemption: (data: any, id: number) =>
        requests.patch(`/customer/contacts/${UserStore.user?.default_contact?.id}/tax-forms/${id}/`, data),
    addTaxExemption: (data: any) =>
        requests.post(`/customer/contacts/${UserStore.user?.default_contact?.id}/tax-forms/`, data),
    removeTaxExemption: (id: number) =>
        requests.delete(`/customer/contacts/${UserStore.user?.default_contact?.id}/tax-forms/${id}/`),

    getNDAForm: () => requests.get(`/customer/contacts/${UserStore.user?.default_contact?.id}/nda-forms/`),
    addNDAForm: (data: any) =>
        requests.post(`/customer/contacts/${UserStore.user?.default_contact?.id}/nda-forms/`, data),
    removeNDAForm: (id: number) =>
        requests.delete(`/customer/contacts/${UserStore.user?.default_contact?.id}/nda-forms/${id}/`),
    editNDAForm: (data: any, id: number) =>
        requests.patch(`/customer/contacts/${UserStore.user?.default_contact?.id}/nda-forms/${id}/`, data),

    getEmailDomains: () => requests.get(`/customer/email-domain/`),
};

/***
 * @deprecated We should use stores
 */
const Orders = {
    all: (params: any) => requests.get(`/customer/sales-orders/`, { params: params }),
    searchBy: (params: any) => requests.get(`/customer/sales-order-line-items/`, { params: params }),
    get: (id: number) => requests.get(`/customer/sales-orders/${id}/`),
    reorder: (payload: any) => requests.post(`/customer/sales-orders/reorder/`, payload),
    previewOrder: (order_id: number) =>
        requests.get(`/customer/sales-orders/${order_id}/download/`, { responseType: 'blob' }),
    // this is the method in question from the Update Request Mail
    requestUpdate: (sales_order_id: number, data: any) =>
        requests.post(`/customer/sales-orders/${sales_order_id}/send-update-request/`, data),
    // this is the method in question from the Update Request Mail
    contactRep: (data: any) => requests.post('/customer/sales-orders/contact-rep/', data),
    contactRequestInvoice: (sales_order_id: number, data: any) =>
        requests.post(`/customer/sales-orders/${sales_order_id}/contact-request-invoice/`, data),
};

/***
 * @deprecated We should use stores
 */
const Quotes = {
    all: (options: any) => requests.get(`/customer/quotes/`, options),
    get: (id: number) => requests.get(`/customer/quotes/${id}/`),
    lineItems: (id: number) => requests.get(`/customer/quotes/${id}/line-items/`),
    addRequestForQuote: (data: any) => requests.post(`/customer/rfqs/`, data),
    downloadQuote: (quote_id: number) =>
        requests.get(`/customer/quotes/${quote_id}/download/`, { responseType: 'blob' }),
    getQuote: (id: number) => requests.get(`/customer/quotes/${id}/`),
    getLineItems: (quote: number) => requests.get(`/customer/quotes/${quote}/line-items/`),
    getAdditionalRequirements: (quote: number) => requests.get(`/customer/quotes/${quote}/additional-requirements/`),
    createDynamicQuote: (quote: number, payload: any) =>
        requests.post(`/customer/quotes/${quote}/create-revision/`, payload),

    newRevision: (quote: number) => requests.post(`/customer/quotes/${quote}/new-revision/`, {}),

    deleteLineItem: (quote: number, payload: any) =>
        requests.post(`/customer/quotes/${quote}/delete-line-item/`, payload),

    addLineItem: (quote: number, payload: any) => requests.post(`/customer/quotes/${quote}/add-line-item/`, payload),

    getPriceLineItem: (quote: number, payload: any) => requests.post(`/customer/quotes/${quote}/get-price/`, payload),

    deleteQuote: (quote: number) => requests.delete(`/customer/quotes/${quote}/`),

    checkExpiredPrice: (quote: number) => requests.get(`/customer/quotes/${quote}/check-expired-price/`),
};

/***
 * @deprecated We should use stores
 */
const Products = {
    all: () => requests.get(`/products/`),
    byId: (id: number) => requests.get(`/products/${id}`),
};

/***
 * @deprecated We should use stores
 */
const Documents = {
    get: () => requests.get(`/customer/documents/`),
    remove: (id: number) => requests.delete(`/customer/documents/${id}/`),
};

/***
 * @deprecated We should use stores
 */
const Contacts = {
    getDefaultAddresses: (contact_id: number) => requests.get(`/customer/contacts/${contact_id}/default-addresses/`),
    getAddressByContact: (contact_id: number) => requests.get(`/customer/contacts/${contact_id}/addresses/`),
    getTaxRate: (contact: number, zip_code: string) =>
        requests.get(`/customer/contacts/${contact}/tax-rate/?zip_code=${zip_code}`),
    inviteYourColleages: (contact_id: number, payload: { first_name: string; last_name: string; email: string }[]) =>
        requests.post(`/customer/contacts/${contact_id}/invite-your-colleagues/`, payload),
    getAllColleagues: (contact_id: number) => requests.get(`/customer/contacts/${contact_id}/colleagues/`),
    removeColleagueInvitation: (contact_id: number, email: string) =>
        requests.post(`/customer/contacts/${contact_id}/remove-colleague-invitation/`, {
            email: email,
        }),
};

/***
 * @deprecated We should use stores
 */
const Notifications = {
    all: () => requests.get(`/notifications/`),
};

const Parts = {
    all: (params: any) => requests.get(`/customer/parts/`, { params: params }),
    getById: (id: number) => requests.get(`/customer/parts/${id}/`),
};

export default {
    /***
     * @deprecated We should use stores
     */
    API_ROOT,
    requests,
    User,
    Orders,
    Quotes,
    Products,
    Documents,
    Notifications,
    Contacts,
    Parts,
};
